module.exports = __webpack_public_path__ + "img/logo.19dbf438.png";